import React, { useEffect, useState } from "react";
import Form from "../../../Reusable/Form/Form.js";
import Image from "components/Elements/Image/Image.tsx";
import Pagination from "../../../Reusable/Pagination/Pagination.js";
import ProfileContactsElement from "../../../Pages/ProfileUser/Contacts/ContactsContainer/ProfileContactsElement.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import {
  ReactGetInboxContacts,
  CreateUserContact,
} from "./ApiContactCalles.js";
import { contactsFields } from "./contactsFields.js";
import { useUser } from "../../../../contexts/userContext/userContext.js";

const CONTACTS_PER_PAGE = 10;

const ContactListWrapper = ({ contactList, listView }) => {
  return (
    <div className="contacts-container">
      {contactList &&
        contactList.map((item, i) => {
          return (
            <ProfileContactsElement
              details={item}
              listView={listView}
              key={i}
            />
          );
        })}
    </div>
  );
};

const ContactsComponent = ({ listView }) => {
  const { getTextByKey } = useContent();
  const { getUserData } = useUser();
  const userData = getUserData();
  const [contactList, setContactList] = useState([]);
  const [contactsQuantity, setContactsQuantity] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const handleSubmit = (body) => {
    return CreateUserContact({
      formBody: body,
      setContactList,
      setContactsQuantity,
      setCurrentPage,
    });
  };

  useEffect(() => {
    if (userData) {
      ReactGetInboxContacts({
        currentPage: currentPage,
        setContactList: setContactList,
        setContactsQuantity: setContactsQuantity,
      });
    }
  }, [userData, currentPage]);

  //upper the num of pages
  function up(v, n) {
    return (
      Math.ceil(v * Math.pow(CONTACTS_PER_PAGE, n)) /
      Math.pow(CONTACTS_PER_PAGE, n)
    );
  }

  return (
    <div className="contacts-wrapper">
      <div className="contact-title">
        {getTextByKey("inbox-contactlist-title")}
      </div>
      <Form
        fieldsProps={{ label: "hidden", field: "square" }}
        fields={contactsFields}
        onSubmit={handleSubmit}
        submitProps={{
          title: getTextByKey("add-contact"),
          className: "add-contact-submit-button",
        }}
        buttonProps={{ buttonsSize: "large" }}
      />
      <ContactListWrapper contactList={contactList} listView={listView} />
      {contactList && contactsQuantity > CONTACTS_PER_PAGE && (
        <Pagination
          maxPages={
            contactsQuantity > 0
              ? up(contactsQuantity / CONTACTS_PER_PAGE, 0)
              : 1
          }
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>
  );
};

export default ContactsComponent;
